module.exports = __webpack_public_path__ + "img/features_16.6b6b7744.png";